import PropTypes from 'prop-types';
import React, { forwardRef, useState } from 'react';
// @mui
import { Box, Stack, Dialog, Grid, Button, AppBar, Typography, Container, Slide, CircularProgress } from '@mui/material';
// components
import { useSettingsContext } from 'src/components/settings/context';
import { setCurrentTreatmentDataGlobal } from 'src/redux/slices/multiTreatment';
import Archive from '../tabs/Archive';
import { clearLead } from '../../redux/slices/lead';
import { dispatch } from '../../redux/store';
import {
    commonDialogHeaderStyle,
    onBoardDialogHeader,
    reminderTitleStyle,
    cancelBoxStyle,
    reminderDialogStyle,
    attendedStackStyle,
    leadFooterButtonsStyle,
    finishButtonStyle
} from '../../styles/ScheduleReminder';

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function OpenRestoreArchived({ open, onClose, type = 'lead', user, inputRef, headerButtons }) {
    const settings = useSettingsContext();
    const [submitting, setSubmitting] = useState(false);

    const handleClose = async () => {
        dispatch(clearLead());
        dispatch(setCurrentTreatmentDataGlobal(null));
        onClose();
    };

    const handleNext = async () => {
        if (submitting) return;
        setSubmitting(true);
        try {
            await inputRef.current.submit('finish');
        } catch (err) {
            console.error('OpenRestoreArchived: submit failed', err);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Dialog
            fullScreen
            TransitionComponent={Transition}
            open={open}
            onClose={handleClose}
            sx={reminderDialogStyle(type)}
        >
            <AppBar sx={headerButtons ? commonDialogHeaderStyle : onBoardDialogHeader}>
                <Typography
                    sx={reminderTitleStyle}
                    variant="h6"
                    component="div"
                >
                    Restore  Lead for <span style={{ textTransform: 'capitalize' }}>{user.first_name}</span>
                </Typography>
                {headerButtons &&
                    <Box sx={cancelBoxStyle}>
                        <Button
                            color="inherit"
                            variant='outlined'
                            style={{ borderColor: 'common.white', color: 'common.white' }}
                            onClick={() => { handleClose('close'); }}
                        >
                            Cancel
                        </Button>
                    </Box>
                }
            </AppBar>
            <Stack spacing={2} sx={attendedStackStyle}>
                <Grid container spacing={1} sx={{ maxWidth: '1088px', margin: 'auto' }}>
                    <Container
                        maxWidth={settings.themeStretch ? false : 'xl'}
                    >
                        <Archive handleClose={handleClose} ref={inputRef} type={type} />
                        <Container
                            maxWidth={settings.themeStretch ? false : 'xl'}
                            sx={leadFooterButtonsStyle}
                        >
                            <Button
                                color="primary"
                                variant='contained'
                                onClick={handleNext}
                                disabled={submitting}
                                startIcon={submitting ? <CircularProgress size={14} sx={{ color: 'common.white' }} /> : null}
                                sx={finishButtonStyle(type)}
                            >
                                {submitting ? 'Finishing…' : 'Finish'}
                            </Button>
                        </Container>
                    </Container>
                </Grid>
            </Stack>
        </Dialog>
    );
}

OpenRestoreArchived.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    type: PropTypes.string,
    user: PropTypes.object,
    inputRef: PropTypes.any,
    headerButtons: PropTypes.bool,
};